import React, { useState } from "react";
import axios from "axios";
import { Landmark, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Per-borrower "eFax Motion to Court" — auto-routes to the district court in the
// borrower's state, warns on CM/ECF-only districts, and refuses (print & mail)
// when no court fax exists. `motionType` = packet | collateral | tro.
export default function CourtEfaxButton({ appId, motionType = "packet" }) {
  const [busy, setBusy] = useState(false);
  const hdr = () => {
    const tk = localStorage.getItem("th_admin_token");
    return tk ? { headers: { Authorization: `Bearer ${tk}` } } : {};
  };

  const run = async () => {
    if (!appId) { window.alert("Open this motion from a specific borrower file to eFax it to the court."); return; }
    setBusy(true);
    try {
      const r = await axios.get(`${API}/admin/courts/resolve/${appId}`, hdr());
      const d = r.data;
      if (d.mail_required || !d.chosen) {
        window.alert(`⚠ CANNOT FAX.\n\n${d.warning}\n\nPlease PRINT and MAIL this motion (or e-file via CM/ECF).`);
        return;
      }
      const c = d.chosen;
      const ok = window.confirm(
        `eFax this ${motionType.toUpperCase()} motion to:\n\n${c.division}, ${c.district}\nFax: ${c.fax}  (${c.fax_motion === "authorized_only" ? "authorized when permitted" : "CM/ECF-only clerk line"})\n\n${d.warning}\n\nSend now?`
      );
      if (!ok) return;
      const res = await axios.post(`${API}/admin/courts/efax-motion/${appId}`, { motion_type: motionType }, hdr());
      const court = res.data.court;
      window.alert(`Sent to ${court.division}, ${court.district} (${res.data.to}) — status: ${res.data.fax?.status || "queued"}.`);
    } catch (err) {
      window.alert(err?.response?.data?.detail || "Could not eFax the motion to the court.");
    } finally { setBusy(false); }
  };

  return (
    <button onClick={run} disabled={busy} data-testid="court-efax-motion-btn"
      title="eFax this motion to the U.S. District Court in the borrower's state (auto-routed to the correct division)."
      style={{ display: "inline-flex", alignItems: "center", gap: 6, background: "transparent", color: "#9DB4E8",
        border: "1px solid #6C8CD5", padding: "9px 14px", borderRadius: 6, fontSize: 11, fontWeight: 700,
        letterSpacing: ".08em", textTransform: "uppercase", cursor: "pointer", opacity: busy ? 0.6 : 1 }}>
      {busy ? <Loader2 size={14} className="animate-spin" /> : <Landmark size={14} />} eFax to Court
    </button>
  );
}
